import { useMutation } from '@tanstack/react-query'
import { useToast } from 'src/shared/hooks/use-toast'
import { useLocalization } from 'src/shared/hooks/useLocalization'

import { ServerRoutes } from './serverRoutes'

interface ContactProps {
  name: string
  email: string
  message: string
}

export const useContact = () => {
  const toast = useToast()
  const { t } = useLocalization()

  return useMutation({
    mutationFn: async (props: ContactProps) => {
      const response = await fetch(
        import.meta.env.VITE_BE_SERVER_URL + ServerRoutes.contact,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            name: props.name,
            email: props.email,
            message: props.message,
          }),
        }
      )

      if (!response.ok) {
        const errorData = await response.json()
        throw new Error(
          errorData.msg || t('Failed to send email', 'Kunde inte skicka e-post')
        )
      }

      return await response.json()
    },
    onError: (error: Error) => {
      toast.toast({
        title: t('Something went wrong', 'Något gick fel'),
        description: error.message,
        variant: 'destructive',
        duration: 5000,
      })
    },
  })
}
